import React from 'react'
import { Switch } from 'react-router-dom'
import { library } from '@fortawesome/fontawesome'
import Icon from '@fortawesome/react-fontawesome'
import brands from '@fortawesome/fontawesome-free-brands'
import solids from '@fortawesome/fontawesome-free-solid'
import regulars from '@fortawesome/fontawesome-free-regular'
import ScrollToTop from 'react-scroll-up'
import { initialize, pageview } from 'react-ga'

import Route from './AuthRoute'
import Home from '../routes/Home'
import Pasar from '../routes/Pasarmina'
import About from '../routes/About'
import Categories from '../routes/Categories'
import Product from '../routes/Product'
import Shop from '../routes/Shop'
import Search from '../routes/Search'
import { Event, SubEvent, EventDetail } from '../routes/Event'
import { Info, SubInfo, InfoDetail } from '../routes/Info'
import {
  Profile,
  Notifications,
  Favorite,
  Pasarmina,
  Eventmina,
  Infomina,
  AddPasarmina,
  AddEventmina,
  AddInfomina,
  Inbox,
  ChangePassword,
} from '../routes/Profile'
import AppHeader from '../common/AppHeader'
import AppFooter from '../common/AppFooter'
import MobileMenu from '../common/Menu/MobileMenu'
import Notification from '../common/Notification'

import './App.scss'

initialize('UA-130886983-1')
pageview(window.location.pathname + window.location.search)

library.add(brands, solids, regulars)

const App = () => (
  <div style={{ position: 'relative' }}>
    <AppHeader />
    <MobileMenu />

    <main>
      <Switch>
        <Route path='/about' component={About} />
        <Route path='/user/profile' component={Profile} />
        <Route path='/user/notifications' component={Notifications} />
        <Route path='/user/favorite' component={Favorite} />
        <Route path='/user/pasarmina' component={Pasarmina} />
        <Route path='/user/eventmina' component={Eventmina} />
        <Route path='/user/infomina' component={Infomina} />
        <Route path='/user/inbox' component={Inbox} />
        <Route path='/user/changepassword' component={ChangePassword} />
        <Route path='/user/add/pasarmina' component={AddPasarmina} />
        <Route path='/user/add/eventmina' component={AddEventmina} />
        <Route path='/user/add/infomina' component={AddInfomina} />
        <Route path='/pasar' component={Pasar} />
        <Route path='/c/:category' component={Categories} />
        <Route path='/p/:product' component={Product} />
        <Route path='/s/:shop' component={Shop} />
        <Route path='/e/:event' component={EventDetail} />
        <Route path='/event/:event' component={SubEvent} />
        <Route path='/event' component={Event} />
        <Route path='/i/:info' component={InfoDetail} />
        <Route path='/info/:info' component={SubInfo} />
        <Route path='/info' component={Info} />
        <Route path='/search' component={Search} />
        <Route path='/' component={Home} />
      </Switch>
    </main>

    <ScrollToTop
      showUnder={600}
      style={{ right: 5, bottom: 55, margin: '0 auto', textAlign: 'center', width: '36px', zIndex: 10 }}>
      <button className='primary__button btt'>
        <Icon icon='angle-double-up' />
      </button>
    </ScrollToTop>
    <AppFooter />
    <div className='active__overlay__full' />
    <Notification />
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/containers/App.js